import Vue from 'vue'
import Vuex from 'vuex'
import {AuthAPI, MethodsAPI, TasksAPI} from 'api-client'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    session: {
      firstName: localStorage.getItem('firstName'),
      token: localStorage.getItem('token') || '',
      newUser: localStorage.getItem('newUser') || true,
      licenseAgreement: localStorage.getItem('lic') || false,
      role: localStorage.getItem('role') || ''
    },
    platforms: [],
    tasks: [],
    taskStates: {
      active: 'PROGRESS',
      finished: 'SUCCESS',
      error: 'ERROR',
      archived: 'ARCHIVED',
      pending: 'PENDING'
    },
    breadcrumbsDynamicRoutes: {},
    errors: {
      login: {},
      registration: {}
    },
    loading: false,
    rightSidebarIsExpanded: false
  },
  mutations: {
    setSession(state, { token, firstName, newUser, licenseAgreement, role}) {
      state.session = { token, firstName, newUser, licenseAgreement, role };
      localStorage.setItem('token', token);
      localStorage.setItem('firstName', firstName);
      localStorage.setItem('newUser', newUser);
      localStorage.setItem('role', role);
      localStorage.setItem('lic', licenseAgreement);
    },
    setErrors(state, { form, errors }) {
      state.errors[form] = errors;
    },
    clearErrors(state) {
      for (const form in state.errors) {
        state.errors[form] = {}
      }
    },
    clearSession(state) {
      state.session.token = '';
      localStorage.removeItem('token');
      localStorage.removeItem('firstName');
      localStorage.removeItem('role');
      localStorage.removeItem('newUser');
    },
    setPlatforms(state, platforms) {
      state.platforms = platforms
    },
    setTasks(state, tasks) {
      state.tasks = tasks
    },
    setBreadcrumbsDynamicRoutes(state, routes) {
      state.breadcrumbsDynamicRoutes = routes
    },
    setUserAsOld(state) {
      state.session.newUser = false
      localStorage.setItem("newUser", false)
    },
    setLicenseAsAgree(state) {
      state.session.licenseAgreement = true
      localStorage.setItem('lic', true)
    },
    abortTask(state, task) {
      state.tasks = state.tasks.filter(el => el.taskId !== task.taskId)
    },
    setLoadingState(state, loading) {
      state.loading = loading
    },
    toggleSidebarState(state) {
      state.rightSidebarIsExpanded = !state.rightSidebarIsExpanded
    }
  },
  getters: {
    isAuthenticated(state) {
      return !!state.session.token
    },
    userIsNew(state) {
      return state.session.newUser === 'true' || state.session.newUser === true
    },
    authData(state) {
      return { token: state.session.token }
    },
    filterTasksByState(state) {
      const tasksByState = {}
      for (const taskState in state.taskStates) {
        const taskStateValue = state.taskStates[taskState]
        tasksByState[taskStateValue] = state.tasks.filter(task => task.state === taskStateValue)
      }
      return tasksByState
    },
    categoriesByPlatform(state) {
      const categoriesByPlatform = {}

      for (const platform of state.platforms) {
        const categories = []
        const platformMethods = platform.methods

        for (const method of platformMethods) {
          const alreadyThere = categories.find(category => category === method.category)
          if (!alreadyThere) {
            categories.push(method.category)
          }
        }

        categoriesByPlatform[platform.code] = categories
      }

      return categoriesByPlatform
    },
    errorsPretty(state) {
      const result = {}

      for (const form in state.errors) {
        result[form] = {}
        const formErrors = state.errors[form]

        for (const field in formErrors) {
          result[form][field] = formErrors[field].join(";")
        }
      }

      return result
    },
    licenseAgreement(state) {
      return state.session.licenseAgreement === true || state.session.licenseAgreement === 'true'
    },
    loading(state) {
      return state.loading
    }
  },
  actions: {
    async logIn({commit, dispatch}, { username, password })  {
      commit('clearErrors');
      try {
        const { token, firstName, activated, role } = await AuthAPI.logIn({ username, password });
        commit('setSession', { token, firstName, newUser: true, licenseAgreement: activated, role: role });
        await dispatch('setupAxiosAuthHeader')
      } catch(errors) {
        commit('setErrors', { form: 'login', errors } )
      }
    },
    logOut({ commit }) {
      AuthAPI.logOut();
      commit('clearSession');
    },
    async fetchPlatforms({ commit }) {
      commit('setLoadingState', true);
      try {
        const platformsAndMethods = await MethodsAPI.listMethods();
        commit('setPlatforms', platformsAndMethods)

      } catch(error) {
        window.console.log(error)
      }
      commit('setLoadingState', false)
    },
    async fetchTasks({ commit }) {
      try {
        const tasks = await TasksAPI.listTasks();
        commit('setTasks', tasks)
      } catch(error) {
        window.console.log(error)
      }
    },
    setupAxiosAuthHeader({state}) {
      if (state.session.token) {
        AuthAPI.setupAxiosHeadersWithToken(state.session.token)
      }
    },
    async markUserAsOld({commit}) {
      commit("setUserAsOld")
    },
    async markUserAsLicenseAgreed({commit}) {
      try {
        await AuthAPI.submitLicenseAgreement();
        commit('setLicenseAsAgree')
      } catch (e) {
        window.console.log("Agreements was not agree")
      }
    },
    async abortTask({commit}, task) {
      try {
        await TasksAPI.abortTask(task);
        commit('abortTask', task)
      } catch (e) {
        window.console.log(e)
      }
    }
  }
})
